import { Team } from "@illa-public/public-types"

export const teamInitialState: Team = {}
